// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.change-cell-layout {
  display: grid;
  grid-template-columns: 1fr;
  gap: 16px;
  width: 100%;
  margin: 0;
}

.change-cell-layout .health-option-set label {
  font-weight: 600;
  color: var(--ui-text);
}

.change-cell-layout textarea {
  width: 100%;
  min-height: 120px;
  resize: vertical;
}

.change-cell-table {
  display: grid;
  grid-template-columns: 1fr;
  gap: 16px;
  width: 100%;
  margin: 0;
}

.change-cell-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  justify-content: flex-end;
}

.change-cell-layout .health-card {
  width: 100%;
}

.change-cell-table .internals-table {
  width: 100%;
}

.change-cell-table .internals-table table {
  width: 100%;
}

.change-cell-remove {
  background: transparent;
  border: 1px solid #f2c9c9;
  color: #c43c3c;
  border-radius: 8px;
  width: 32px;
  height: 32px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}

/* estilo criar transferencia */
.container-transfer {
  width: 100%;
}

.container-transfer .transfer-unit-form {
  display: grid;
  grid-template-columns: 1fr;
  gap: 16px;
  width: 100%;
}

.container-transfer .transfer-unit-form .health-card {
  width: 100%;
}

.container-transfer .transfer-unit-form .health-option-set textarea {
  min-height: 120px;
  resize: vertical;
}

.content-filters {
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
}

.content-filters .health-card {
  width: 100%;
}

.transfer-modal {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.transfer-profile-card {
  display: flex;
  flex-direction: column;
  gap: 18px;
  padding: 18px;
  border-radius: 18px;
  border: 1px solid #d9e4ff;
  background: linear-gradient(135deg, #f8fbff 0%, #eef4ff 100%);
}

.transfer-profile-top {
  display: grid;
  grid-template-columns: auto minmax(0, 1fr);
  align-items: center;
  gap: 16px;
}

.transfer-profile-avatar {
  width: 108px;
  height: 108px;
  border-radius: 999px;
  overflow: hidden;
  border: 3px solid #ffffff;
  box-shadow: 0 10px 22px rgba(18, 72, 170, 0.22);
  background: #d9e5ff;
  display: flex;
  align-items: center;
  justify-content: center;
}

.transfer-profile-avatar img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.transfer-profile-avatar-fallback {
  color: #1f4ea0;
  font-size: 28px;
  font-weight: 800;
  letter-spacing: 0.04em;
}

.transfer-profile-content {
  display: flex;
  flex-direction: column;
  gap: 10px;
  min-width: 0;
}

.transfer-profile-content h3 {
  margin: 0;
  color: #1f2f5e;
  font-size: 18px;
  line-height: 1.2;
  word-break: break-word;
}

.transfer-profile-subtitle {
  margin: 0;
  color: #5970a6;
  font-size: 11px;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  font-weight: 700;
}

.transfer-flow-block {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.transfer-profile-route-board {
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto minmax(0, 1fr);
  align-items: center;
  gap: 12px;
}

.transfer-route-card {
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 4px;
  min-height: 76px;
  justify-content: center;
  padding: 12px 14px;
  border: 1px solid #d5e2ff;
  border-radius: 12px;
  background: #ffffff;
  box-shadow: 0 6px 16px rgba(16, 57, 138, 0.07);
  min-width: 0;
}

.transfer-route-card::before {
  content: '';
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  width: 4px;
  border-radius: 12px 0 0 12px;
}

.transfer-route-origin::before {
  background: #6b8ee8;
}

.transfer-route-destination::before {
  background: #3fa57a;
}

.transfer-route-label {
  font-size: 10px;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: #687b9f;
  font-weight: 700;
}

.transfer-route-card strong {
  color: #243d72;
  font-size: 12px;
  line-height: 1.35;
  word-break: normal;
  overflow-wrap: break-word;
  font-weight: 600;
}

.transfer-route-divider {
  display: flex;
  align-items: center;
  gap: 6px;
  color: #6b8ee8;
}

.transfer-route-line {
  width: 20px;
  height: 1px;
  background: #b7c7eb;
}

.transfer-route-arrow {
  width: 30px;
  height: 30px;
  border-radius: 999px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  font-weight: 700;
  color: #3f63b8;
  background: #e8efff;
  border: 1px solid #c7d7ff;
}

.transfer-profile-meta {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
  color: #41527f;
  font-size: 12px;
  font-weight: 600;
}

.transfer-profile-chip {
  background: #e9efff;
  color: #304781;
  border-radius: 999px;
  padding: 5px 10px;
  font-size: 11px;
  font-weight: 700;
}

.transfer-profile-status {
  display: inline-flex;
  align-items: center;
  gap: 6px;
}

.transfer-profile-status-label {
  color: #4d6092;
  font-size: 11px;
  font-weight: 700;
}

.transfer-profile-status .status-vermelho,
.transfer-profile-status .status-verde,
.transfer-profile-status .status-azul,
.transfer-profile-status .status-amarelo {
  font-size: 11px;
  padding: 4px 10px;
}

.transfer-modal-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 12px;
}

.transfer-modal-field {
  display: flex;
  flex-direction: column;
  gap: 6px;
  padding: 14px;
  border: 1px solid #dae5ff;
  border-radius: 14px;
  background: #fdfefe;
  box-shadow: 0 2px 8px rgba(23, 56, 133, 0.05);
}

.transfer-modal-field span {
  font-size: 10px;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  color: #60739e;
  font-weight: 700;
}

.transfer-modal-field strong {
  font-size: 15px;
  line-height: 1.3;
  color: #1f2f54;
  word-break: normal;
  overflow-wrap: break-word;
  font-weight: 600;
}

.transfer-modal-field-wide {
  grid-column: 1 / -1;
}

.transfer-modal-field-process strong {
  letter-spacing: 0.02em;
  font-size: 14px;
}

.transfer-modal-field-reason strong {
  font-size: 14px;
}

.transfer-modal-field-flag strong {
  font-size: 20px;
}

.transfer-modal-input {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.transfer-modal-input label {
  font-weight: 600;
  color: var(--ui-text);
}

.transfer-modal-input textarea {
  min-height: 100px;
  resize: vertical;
}

.transfer-modal-block {
  padding: 10px;
  border: 1px solid var(--ui-border);
  border-radius: 12px;
  background: var(--ui-input-bg);
}

.transfer-modal-actions {
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
  justify-content: flex-end;
}

.transfer-modal-actions .btnConfirmar {
  display: inline-flex;
  align-items: center;
  gap: 8px;
}

.transfer-modal-actions .btnConfirmar.danger {
  background: var(--Vermelho);
  border-color: transparent;
  color: #fff;
}

@media (max-width: 900px) {
  .transfer-profile-card {
    padding: 14px;
  }

  .transfer-profile-top {
    grid-template-columns: 1fr;
    justify-items: center;
    text-align: center;
  }

  .transfer-profile-content {
    align-items: center;
  }

  .transfer-profile-route-board {
    grid-template-columns: 1fr;
    width: 100%;
  }

  .transfer-route-divider {
    justify-content: center;
  }

  .transfer-route-line {
    display: none;
  }

  .transfer-route-arrow {
    transform: rotate(90deg);
  }

  .transfer-modal-grid {
    grid-template-columns: 1fr;
  }

  .transfer-modal-field-flag strong {
    font-size: 18px;
  }
}

.trasfer-table,
.cellchange-table {
  width: 100%;
  padding: 20px 0;
  box-shadow: 0px 0px 6px rgba(0, 0, 0, 0.1) !important;
}

:is(.trasfer-table,.cellchange-table)  > internal-table,:is(.trasfer-table,.cellchange-table) table thead tr,:is(.trasfer-table,.cellchange-table) td {
    background-color: #fff;
  }

:is(.trasfer-table,.cellchange-table) .btnAdcionar {
    margin: 20px;
  }

.action-buttons {
  display: flex;
  justify-content: flex-end;
}

.form-busca-interno>div>input,
.form-busca-interno select {
  border: 1px solid #ccc !important;
}



.status-vermelho {
  color: #FA5A7D;
  background-color: #FFE2E5;
  padding: 6px 12px;
  border-radius: 8px;
  font-weight: bold;
}

.status-verde {
  color: #00B087;
  background-color: #CFFAEA;
  padding: 6px 12px;
  border-radius: 8px;
  font-weight: bold;
}

.status-azul {
  color: var(--texto-destaque);
  background-color: #D2DFFF;
  padding: 6px 12px;
  border-radius: 8px;
  font-weight: bold;
}

.status-amarelo {
  color: #b58900;
  background-color: wheat;
  padding: 6px 12px;
  border-radius: 8px;
  font-weight: bold;
}

.btnTransfer{
  float: left !important;
}

/* Estilo para os filtros */
.content-filters .trasfer-table {
  padding: 20px 0;
  box-shadow: 0px 0px 6px rgba(0, 0, 0, 0.1) !important;
  margin: 20px 0 40px 0;
}
:is(.content-filters .trasfer-table) .internals-table > table thead {
    background-color: #fff !important;
  }

.title-buttons-trasnfers {
  display: flex;
  gap: 10px;
}

.title-buttons-trasnfers  > button {
    border-radius: 10px;
  }

.filters {
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  gap: 1rem;
  margin-bottom: 1rem;
  border-radius: 8px;
}

.filters  > div {
    display: flex;
    gap: 40px;
  }

.filter-group {
  display: flex;
  flex-direction: column;
  flex: 1 1;
  min-width: 200px;
  background-color: #fff;
  padding: 10px;
}

.filter-group  > input[type=text],.filter-group input[type=date],.filter-group select {
    background-color: #fff;
    border: 1px solid var(--borda);
    color: #292d32b4;
    padding: 10px !important;
  }

.btn-filter-group {
  display: flex;
  justify-content: flex-end;
  gap: 10px !important;
}

.btn-filter-group .btn-apply {
    font-size: 16px;
    font-weight: 600;
    border-radius: 10px;
  }

.btn-filter-group .btn-reset {
    background-color: #fff;
    color: var(--texto-destaque);
    border-radius: 10px;
    font-size: 16px;
    font-weight: 600;
  }
`, "",{"version":3,"sources":["webpack://./src/pages/Transferencia/transferencias.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,0BAA0B;EAC1B,SAAS;EACT,WAAW;EACX,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,0BAA0B;EAC1B,SAAS;EACT,WAAW;EACX,SAAS;AACX;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,yBAAyB;AAC3B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,uBAAuB;EACvB,yBAAyB;EACzB,cAAc;EACd,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;AACjB;;AAEA,+BAA+B;AAC/B;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,0BAA0B;EAC1B,SAAS;EACT,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,6DAA6D;AAC/D;;AAEA;EACE,aAAa;EACb,0CAA0C;EAC1C,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,oBAAoB;EACpB,gBAAgB;EAChB,yBAAyB;EACzB,+CAA+C;EAC/C,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,YAAY;AACd;;AAEA;EACE,SAAS;EACT,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,eAAe;EACf,sBAAsB;EACtB,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,yDAAyD;EACzD,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,gBAAgB;EAChB,uBAAuB;EACvB,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;EACnB,8CAA8C;EAC9C,YAAY;AACd;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,OAAO;EACP,MAAM;EACN,SAAS;EACT,UAAU;EACV,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,yBAAyB;EACzB,sBAAsB;EACtB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,oBAAoB;EACpB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;;;;EAIE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;EACnB,6CAA6C;AAC/C;;AAEA;EACE,eAAe;EACf,yBAAyB;EACzB,sBAAsB;EACtB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,kCAAkC;EAClC,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,SAAS;EACT,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,2BAA2B;EAC3B,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,0BAA0B;IAC1B,qBAAqB;IACrB,kBAAkB;EACpB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,0BAA0B;IAC1B,WAAW;EACb;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;;EAEE,WAAW;EACX,eAAe;EACf,qDAAqD;AAWvD;;AATE;IAGE,sBAAsB;EACxB;;AAEA;IACE,YAAY;EACd;;AAGF;EACE,aAAa;EACb,yBAAyB;AAC3B;;AAEA;;EAEE,iCAAiC;AACnC;;;;AAIA;EACE,cAAc;EACd,yBAAyB;EACzB,iBAAiB;EACjB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,iBAAiB;EACjB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,4BAA4B;EAC5B,yBAAyB;EACzB,iBAAiB;EACjB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,uBAAuB;EACvB,iBAAiB;EACjB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,sBAAsB;AACxB;;AAEA,2BAA2B;AAC3B;EACE,eAAe;EACf,qDAAqD;EACrD,qBAAqB;AAKvB;AAHE;IACE,iCAAiC;EACnC;;AAGF;EACE,aAAa;EACb,SAAS;AAKX;;AAHE;IACE,mBAAmB;EACrB;;AAGF;EACE,aAAa;EACb,sBAAsB;EACtB,eAAe;EACf,SAAS;EACT,mBAAmB;EACnB,kBAAkB;AAMpB;;AAJE;IACE,aAAa;IACb,SAAS;EACX;;AAGF;EACE,aAAa;EACb,sBAAsB;EACtB,SAAO;EACP,gBAAgB;EAChB,sBAAsB;EACtB,aAAa;AAUf;;AARE;IAGE,sBAAsB;IACtB,8BAA8B;IAC9B,gBAAgB;IAChB,wBAAwB;EAC1B;;AAGF;EACE,aAAa;EACb,yBAAyB;EACzB,oBAAoB;AAetB;;AAbE;IACE,eAAe;IACf,gBAAgB;IAChB,mBAAmB;EACrB;;AAEA;IACE,sBAAsB;IACtB,4BAA4B;IAC5B,mBAAmB;IACnB,eAAe;IACf,gBAAgB;EAClB","sourcesContent":[".change-cell-layout {\n  display: grid;\n  grid-template-columns: 1fr;\n  gap: 16px;\n  width: 100%;\n  margin: 0;\n}\n\n.change-cell-layout .health-option-set label {\n  font-weight: 600;\n  color: var(--ui-text);\n}\n\n.change-cell-layout textarea {\n  width: 100%;\n  min-height: 120px;\n  resize: vertical;\n}\n\n.change-cell-table {\n  display: grid;\n  grid-template-columns: 1fr;\n  gap: 16px;\n  width: 100%;\n  margin: 0;\n}\n\n.change-cell-actions {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 10px;\n  justify-content: flex-end;\n}\n\n.change-cell-layout .health-card {\n  width: 100%;\n}\n\n.change-cell-table .internals-table {\n  width: 100%;\n}\n\n.change-cell-table .internals-table table {\n  width: 100%;\n}\n\n.change-cell-remove {\n  background: transparent;\n  border: 1px solid #f2c9c9;\n  color: #c43c3c;\n  border-radius: 8px;\n  width: 32px;\n  height: 32px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n}\n\n/* estilo criar transferencia */\n.container-transfer {\n  width: 100%;\n}\n\n.container-transfer .transfer-unit-form {\n  display: grid;\n  grid-template-columns: 1fr;\n  gap: 16px;\n  width: 100%;\n}\n\n.container-transfer .transfer-unit-form .health-card {\n  width: 100%;\n}\n\n.container-transfer .transfer-unit-form .health-option-set textarea {\n  min-height: 120px;\n  resize: vertical;\n}\n\n.content-filters {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  width: 100%;\n}\n\n.content-filters .health-card {\n  width: 100%;\n}\n\n.transfer-modal {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n.transfer-profile-card {\n  display: flex;\n  flex-direction: column;\n  gap: 18px;\n  padding: 18px;\n  border-radius: 18px;\n  border: 1px solid #d9e4ff;\n  background: linear-gradient(135deg, #f8fbff 0%, #eef4ff 100%);\n}\n\n.transfer-profile-top {\n  display: grid;\n  grid-template-columns: auto minmax(0, 1fr);\n  align-items: center;\n  gap: 16px;\n}\n\n.transfer-profile-avatar {\n  width: 108px;\n  height: 108px;\n  border-radius: 999px;\n  overflow: hidden;\n  border: 3px solid #ffffff;\n  box-shadow: 0 10px 22px rgba(18, 72, 170, 0.22);\n  background: #d9e5ff;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.transfer-profile-avatar img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  display: block;\n}\n\n.transfer-profile-avatar-fallback {\n  color: #1f4ea0;\n  font-size: 28px;\n  font-weight: 800;\n  letter-spacing: 0.04em;\n}\n\n.transfer-profile-content {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  min-width: 0;\n}\n\n.transfer-profile-content h3 {\n  margin: 0;\n  color: #1f2f5e;\n  font-size: 18px;\n  line-height: 1.2;\n  word-break: break-word;\n}\n\n.transfer-profile-subtitle {\n  margin: 0;\n  color: #5970a6;\n  font-size: 11px;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n  font-weight: 700;\n}\n\n.transfer-flow-block {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.transfer-profile-route-board {\n  display: grid;\n  grid-template-columns: minmax(0, 1fr) auto minmax(0, 1fr);\n  align-items: center;\n  gap: 12px;\n}\n\n.transfer-route-card {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  min-height: 76px;\n  justify-content: center;\n  padding: 12px 14px;\n  border: 1px solid #d5e2ff;\n  border-radius: 12px;\n  background: #ffffff;\n  box-shadow: 0 6px 16px rgba(16, 57, 138, 0.07);\n  min-width: 0;\n}\n\n.transfer-route-card::before {\n  content: '';\n  position: absolute;\n  left: 0;\n  top: 0;\n  bottom: 0;\n  width: 4px;\n  border-radius: 12px 0 0 12px;\n}\n\n.transfer-route-origin::before {\n  background: #6b8ee8;\n}\n\n.transfer-route-destination::before {\n  background: #3fa57a;\n}\n\n.transfer-route-label {\n  font-size: 10px;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n  color: #687b9f;\n  font-weight: 700;\n}\n\n.transfer-route-card strong {\n  color: #243d72;\n  font-size: 12px;\n  line-height: 1.35;\n  word-break: normal;\n  overflow-wrap: break-word;\n  font-weight: 600;\n}\n\n.transfer-route-divider {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  color: #6b8ee8;\n}\n\n.transfer-route-line {\n  width: 20px;\n  height: 1px;\n  background: #b7c7eb;\n}\n\n.transfer-route-arrow {\n  width: 30px;\n  height: 30px;\n  border-radius: 999px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 16px;\n  font-weight: 700;\n  color: #3f63b8;\n  background: #e8efff;\n  border: 1px solid #c7d7ff;\n}\n\n.transfer-profile-meta {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  flex-wrap: wrap;\n  color: #41527f;\n  font-size: 12px;\n  font-weight: 600;\n}\n\n.transfer-profile-chip {\n  background: #e9efff;\n  color: #304781;\n  border-radius: 999px;\n  padding: 5px 10px;\n  font-size: 11px;\n  font-weight: 700;\n}\n\n.transfer-profile-status {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.transfer-profile-status-label {\n  color: #4d6092;\n  font-size: 11px;\n  font-weight: 700;\n}\n\n.transfer-profile-status .status-vermelho,\n.transfer-profile-status .status-verde,\n.transfer-profile-status .status-azul,\n.transfer-profile-status .status-amarelo {\n  font-size: 11px;\n  padding: 4px 10px;\n}\n\n.transfer-modal-grid {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 12px;\n}\n\n.transfer-modal-field {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  padding: 14px;\n  border: 1px solid #dae5ff;\n  border-radius: 14px;\n  background: #fdfefe;\n  box-shadow: 0 2px 8px rgba(23, 56, 133, 0.05);\n}\n\n.transfer-modal-field span {\n  font-size: 10px;\n  text-transform: uppercase;\n  letter-spacing: 0.06em;\n  color: #60739e;\n  font-weight: 700;\n}\n\n.transfer-modal-field strong {\n  font-size: 15px;\n  line-height: 1.3;\n  color: #1f2f54;\n  word-break: normal;\n  overflow-wrap: break-word;\n  font-weight: 600;\n}\n\n.transfer-modal-field-wide {\n  grid-column: 1 / -1;\n}\n\n.transfer-modal-field-process strong {\n  letter-spacing: 0.02em;\n  font-size: 14px;\n}\n\n.transfer-modal-field-reason strong {\n  font-size: 14px;\n}\n\n.transfer-modal-field-flag strong {\n  font-size: 20px;\n}\n\n.transfer-modal-input {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.transfer-modal-input label {\n  font-weight: 600;\n  color: var(--ui-text);\n}\n\n.transfer-modal-input textarea {\n  min-height: 100px;\n  resize: vertical;\n}\n\n.transfer-modal-block {\n  padding: 10px;\n  border: 1px solid var(--ui-border);\n  border-radius: 12px;\n  background: var(--ui-input-bg);\n}\n\n.transfer-modal-actions {\n  display: flex;\n  gap: 10px;\n  flex-wrap: wrap;\n  justify-content: flex-end;\n}\n\n.transfer-modal-actions .btnConfirmar {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.transfer-modal-actions .btnConfirmar.danger {\n  background: var(--Vermelho);\n  border-color: transparent;\n  color: #fff;\n}\n\n@media (max-width: 900px) {\n  .transfer-profile-card {\n    padding: 14px;\n  }\n\n  .transfer-profile-top {\n    grid-template-columns: 1fr;\n    justify-items: center;\n    text-align: center;\n  }\n\n  .transfer-profile-content {\n    align-items: center;\n  }\n\n  .transfer-profile-route-board {\n    grid-template-columns: 1fr;\n    width: 100%;\n  }\n\n  .transfer-route-divider {\n    justify-content: center;\n  }\n\n  .transfer-route-line {\n    display: none;\n  }\n\n  .transfer-route-arrow {\n    transform: rotate(90deg);\n  }\n\n  .transfer-modal-grid {\n    grid-template-columns: 1fr;\n  }\n\n  .transfer-modal-field-flag strong {\n    font-size: 18px;\n  }\n}\n\n.trasfer-table,\n.cellchange-table {\n  width: 100%;\n  padding: 20px 0;\n  box-shadow: 0px 0px 6px rgba(0, 0, 0, 0.1) !important;\n\n  >internal-table,\n  table thead tr,\n  td {\n    background-color: #fff;\n  }\n\n  .btnAdcionar {\n    margin: 20px;\n  }\n}\n\n.action-buttons {\n  display: flex;\n  justify-content: flex-end;\n}\n\n.form-busca-interno>div>input,\n.form-busca-interno select {\n  border: 1px solid #ccc !important;\n}\n\n\n\n.status-vermelho {\n  color: #FA5A7D;\n  background-color: #FFE2E5;\n  padding: 6px 12px;\n  border-radius: 8px;\n  font-weight: bold;\n}\n\n.status-verde {\n  color: #00B087;\n  background-color: #CFFAEA;\n  padding: 6px 12px;\n  border-radius: 8px;\n  font-weight: bold;\n}\n\n.status-azul {\n  color: var(--texto-destaque);\n  background-color: #D2DFFF;\n  padding: 6px 12px;\n  border-radius: 8px;\n  font-weight: bold;\n}\n\n.status-amarelo {\n  color: #b58900;\n  background-color: wheat;\n  padding: 6px 12px;\n  border-radius: 8px;\n  font-weight: bold;\n}\n\n.btnTransfer{\n  float: left !important;\n}\n\n/* Estilo para os filtros */\n.content-filters .trasfer-table {\n  padding: 20px 0;\n  box-shadow: 0px 0px 6px rgba(0, 0, 0, 0.1) !important;\n  margin: 20px 0 40px 0;\n\n  .internals-table>table thead {\n    background-color: #fff !important;\n  }\n}\n\n.title-buttons-trasnfers {\n  display: flex;\n  gap: 10px;\n\n  >button {\n    border-radius: 10px;\n  }\n}\n\n.filters {\n  display: flex;\n  flex-direction: column;\n  flex-wrap: wrap;\n  gap: 1rem;\n  margin-bottom: 1rem;\n  border-radius: 8px;\n\n  >div {\n    display: flex;\n    gap: 40px;\n  }\n}\n\n.filter-group {\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n  min-width: 200px;\n  background-color: #fff;\n  padding: 10px;\n\n  >input[type=text],\n  input[type=date],\n  select {\n    background-color: #fff;\n    border: 1px solid var(--borda);\n    color: #292d32b4;\n    padding: 10px !important;\n  }\n}\n\n.btn-filter-group {\n  display: flex;\n  justify-content: flex-end;\n  gap: 10px !important;\n\n  .btn-apply {\n    font-size: 16px;\n    font-weight: 600;\n    border-radius: 10px;\n  }\n\n  .btn-reset {\n    background-color: #fff;\n    color: var(--texto-destaque);\n    border-radius: 10px;\n    font-size: 16px;\n    font-weight: 600;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
